import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// components
import { FavoritesItem } from '../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../components/global/FavoriteIcons/FavoritesProvider';
import { addForceFavoriteRefetchHandler } from 'dibs-buyer-layout/exports/loginHandlers';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';

export function PdpSharedSidebarFavorites(props) {
    // Todo: Directly pass in userId
    const { isClient, itemId, environment, userId } = props;
    const [shouldFavoritesProviderRefetch, setShouldFavoritesProviderRefetch] = useState(false);

    useEffect(() => {
        addForceFavoriteRefetchHandler(() => {
            setShouldFavoritesProviderRefetch(true);
        });
    }, [setShouldFavoritesProviderRefetch]);

    return (
        <FavoritesProvider
            environment={environment}
            location={locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[itemId]}
            shouldAutoFavorite
            shouldRefetch={shouldFavoritesProviderRefetch}
        >
            {
                // eslint-disable-next-line
                ({ props: renderProps }) => (
                    <FavoritesItem
                        {...renderProps}
                        itemId={itemId}
                        itemTitle={props.itemTitle}
                        itemImage={props.itemImage}
                        wrapperClass={props.wrapperClass}
                        heartIconWrapperClass={props.heartIconWrapperClass}
                        folderIconWrapperClass={props.folderIconWrapperClass}
                        showTooltipOnFirstClick
                        type={props.type}
                        isStrokeWidthHeavy={props.isStrokeWidthHeavy}
                    />
                )
            }
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    isClient: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemTitle: PropTypes.string,
    itemImage: PropTypes.string,
    type: PropTypes.oneOf(['outline', 'button']),
    isStrokeWidthHeavy: PropTypes.bool,
};
